<a class="shop-item-card {{colorScheme.main}}"
   *ngIf="item.shopUrl"
   target="_blank"
   [href]="item.shopUrl">
  <img class="image" loading="lazy" [src]="item.imgUrl" alt="Shop Item">
  <div class="info">
    <span class="title">{{ item.title }}</span>
    <span class="subtitle">{{ item.subtitle }}</span>
    <div class="prices">
      <span class="price {{colorScheme.accent}}">{{ item.price }}</span>
      <span class="price-was">{{ item.priceWas }}</span>
    </div>
  </div>
</a>


